export const config = {
  src: [
    'audiosprites/audio.ogg',
    'audiosprites/audio.mp3',
  ],
  sprite: {
    big_win: [
      0,
      16026.122448979591,
    ],
    button_spin: [
      18000,
      1165.3514739229038,
    ],
    free_bet_big_win: [
      21000,
      1377.2335600907013,
    ],
    free_bet_mega_win: [
      24000,
      2213.151927437643,
    ],
    free_bet_total_win: [
      28000,
      979.591836734695,
    ],
    free_bet_ultra_win: [
      30000,
      1319.1836734693893,
    ],
    inside_buttons: [
      33000,
      285.89569160997996,
    ],
    main_ambient: [
      35000,
      72177.77777777778,
    ],
    main_music: [
      109000,
      133218.68480725624,
    ],
    mega_win: [
      244000,
      11695.600907029473,
    ],
    outside_buttons: [
      257000,
      544.2176870748199,
    ],
    reel_spin: [
      259000,
      3155.0113378684728,
    ],
    reel_stop_01: [
      264000,
      338.14058956915005,
    ],
    reel_stop_02: [
      266000,
      282.9931972789268,
    ],
    reel_stop_03: [
      268000,
      355.5555555555543,
    ],
    regular_win: [
      270000,
      1441.0884353741267,
    ],
    respin: [
      273000,
      5513.287981859435,
    ],
    tap_to_play: [
      280000,
      10084.71655328799,
    ],
    ultra_win: [
      292000,
      9954.104308390015,
    ],
    x2_win: [
      303000,
      3591.8367346938567,
    ],
  },
}
